import { Theme } from "@mui/material";

export const DRAWER_WIDTH = 240;
export const APPBAR_HEIGHT = 72;

const contentPanel = {
  flex: 1,
  p: 3,
  overflowY: "auto",
  display: "flex",
  flexDirection: "column"
} as const;

export const styles = {
  root: {
    display: "flex",
    height: "100vh",
    overflow: "hidden"
  },
  appBar: {
    zIndex: (theme: Theme) => theme.zIndex.drawer + 1
  },
  toolbar: {
    minHeight: `${APPBAR_HEIGHT}px`
  },
  drawer: (open: boolean) => ({
    width: open ? DRAWER_WIDTH : 0,
    flexShrink: 0,
    transition: "width 0.2s",
    "& .MuiDrawer-paper": {
      width: DRAWER_WIDTH,
      boxSizing: "border-box",
      top: `${APPBAR_HEIGHT}px`,
      height: `calc(100vh - ${APPBAR_HEIGHT}px)`
    }
  }),
  content: {
    flexGrow: 1,
    mt: `${APPBAR_HEIGHT}px`,
    height: `calc(100vh - ${APPBAR_HEIGHT}px)`,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden"
  },
  contentPanel,
  contentPanelVisible: (visible: boolean) => ({
    ...contentPanel,
    display: visible ? "flex" : "none"
  }),
  menuButton: {
    mr: 2
  },
  logoWrapper: {
    display: "flex",
    alignItems: "center",
    bgcolor: "background.paper",
    borderRadius: 1,
    px: 1.5,
    py: 0.75,
    width: "fit-content",
    "&:hover": {
      opacity: 0.85
    }
  },
  logo: {
    height: 44,
    display: "block"
  },
  sairButton: {
    ml: "auto"
  },
  menuItemPadding: (pl: number) => ({ pl })
} as const;
